import { POWER_APP_PATH_PARAM_NAME } from '@/features/PowerApps/hooks/usePowerAppsDeepNavigation';
import { isPortalPathname } from '@/utils/portal';
import React from 'react';

export const usePowerAppsQueryParams = () => {
  const [queryParams, setQueryParams] = React.useState('');

  const setPowerAppsQueryParams = React.useCallback(({ pathname = '', search = '' }) => {
    if (!pathname) return setQueryParams(search);

    if (!isPortalPathname(pathname)) return setQueryParams('');
    if (!search) return setQueryParams('');
    if (!search.startsWith(`?${POWER_APP_PATH_PARAM_NAME}=`)) return setQueryParams('');
    setQueryParams(search);
  }, []);

  return { queryParams, setQueryParams: setPowerAppsQueryParams };
};
